import React from "react"

import LayoutHeaderMenu from "../LayoutHeaderMenu/LayoutHeaderMenu"

import TrainingCarousel from "./TrainingCarousel"

import "./trainings.scss"

const Trainings = (props) => {
  const uri = props.uri.split("/")

  const {
    set_metadata,
    text_header_title,
    text_header_description,
    asset_header_picture,
    asset_logo,
    text_title,
    wysiwyg_short_description,
    wysiwyg_description,
    arr_trainings_cards,
  } = props.pageContext.content.services_trainings

  const siteMetadata = {
    title: set_metadata.text_page_title,
    description: set_metadata.text_page_description,
    meta: [
      {
        name: "keywords",
        content: set_metadata.text_keywords,
      },
    ],
    author: `prodHost`,
  }

  return (
    <div className="trainings-wrapper">
      <LayoutHeaderMenu
        siteMetadata={siteMetadata}
        header_logo={
          props.pageContext.content.global_values.set_logos
            .asset_prodhost_logo_white_120p
        }
        header_title={text_header_title}
        header_description={text_header_description}
        header_background={`${process.env.GATSBY_CMS_URL_STORAGE_UPLOADS_2}${asset_header_picture.path}`}
        header_shaded
        menu={props.pageContext.menu.entries}
        selected={`${uri[1]}`}
        selected2={`${uri[1]}_${uri[2]}`}
        expanded
        footer={props.pageContext.content.global_values.set_footer}
      >
        <div className="layout-industries-head">
          <div className="image-wrapper">
            <img
              src={`${process.env.GATSBY_CMS_URL_STORAGE_UPLOADS_2}${asset_logo.path}`}
              alt="product_modules_logo"
            />
          </div>
          <div className="layout-industries-title">
            <h1>{text_title}</h1>
            <div
              className="description"
              dangerouslySetInnerHTML={{ __html: wysiwyg_short_description }}
            ></div>
          </div>
        </div>
        <div
          className="description"
          dangerouslySetInnerHTML={{ __html: wysiwyg_description }}
        ></div>
        <TrainingCarousel carousel={arr_trainings_cards} />
      </LayoutHeaderMenu>
    </div>
  )
}

export default Trainings
